import { fmtAbsolute, fmtCost, fmtDuration, fmtNum } from '../shared/formatters';
import type { AgentMinerTurn } from '../../../api/agent-miner-client/agent-miner-client.type';
import type { TurnMetaItem } from './turn-panel.type';

/**
 * Builds the turn panel's metadata rows: start time, duration, token counts
 * and, when the viewer may see it, API cost. Missing token counts read as 0,
 * and the cache figure (creation + read) is only shown when non-zero.
 *
 * @param {AgentMinerTurn} turn - The turn being summarized
 * @param {boolean} showApiCost - Whether the viewer may see API cost
 * @returns {TurnMetaItem[]} The rows, in display order
 */
const buildTurnMetadata = (turn: AgentMinerTurn, showApiCost: boolean): TurnMetaItem[] => {
  const inTokens = turn.input_tokens ?? 0;
  const outTokens = turn.output_tokens ?? 0;
  const cacheTokens = (turn.cache_creation_tokens ?? 0) + (turn.cache_read_tokens ?? 0);

  const metadata: TurnMetaItem[] = [];
  metadata.push({ iconName: 'schedule', label: 'Started', value: fmtAbsolute(turn.started_at) });
  metadata.push({ iconName: 'timer', label: 'Duration', value: fmtDuration(turn.duration_ms) });
  metadata.push({
    iconName: 'memory',
    label: 'Tokens',
    value: `${fmtNum(inTokens)} in · ${fmtNum(outTokens)} out${cacheTokens > 0 ? ` · +${fmtNum(cacheTokens)} cache` : ''}`,
  });
  if (showApiCost) metadata.push({ iconName: 'payments', label: 'API cost', value: fmtCost(turn.cost_usd) });
  return metadata;
};

export { buildTurnMetadata };
